module.exports = __webpack_public_path__ + "img/b_immun_front_2.d2e537ac.jpeg";